import React from "react";
import Synonyms from "./Synonyms";
import "./Meaning.css";

export default function Meaning(props) {
    return (
        <div className="Meaning">
            {/* display partOfSpeech = noun or adjective */}
            <h3>{props.meaning.partOfSpeech}</h3>
            {/* definitions is an array (one or multiple definitions) */}
            {/* going through each definition */}
            {props.meaning.definitions.map(function (definition, index)
            {
                return (
                    <div key={index}>
                        {/* display definition */}
                        <div className="definition">
                        {definition.definition}</div>
                        {/* display example */}
                        <div className="example">
                        {definition.example}</div>
                        {/* component for Synonyms */}
                        <Synonyms synonyms={definition.synonyms} />
                    </div>
                );
            })}
        </div>
    );
}